export default "__VITE_ASSET__2IfKVHCd__"